import userService from 'api/user';
import goalService from 'api/goal';

export default {
  changePassword: (hash, newPassword) => userService.changePassword(hash, newPassword),

  setCurrentGoal: (goal) => (dispatch) => {
    dispatch({ type: 'GET_PUBLIC_GOAL', data: goal });
  },

  getPublicInformation: (userName, goalName) => (dispatch) => {
    dispatch({ type: 'GET_USER_PUBLIC' });

    // get public info
    const getPublicInfo = new Promise((resolve, reject) => {
      userService.getPublicInformationByUsername(userName)
        .then((response) => {
          response.json().then((users) => {
            if (users.length > 0) {
              const user = users[0];
              resolve(user);
            } else {
              reject(new Error('Invalid user name'));
            }
          });
        }).catch((error) => {
          reject(error);
        });
    });

    // get public goals
    const getPublicGoals = (userId) => new Promise((resolve, reject) => {
      userService.getPublicGoals(userId)
        .then((response) => {
          response.json().then((goals) => {
            resolve(goals);
          });
        });
    });
    // get public investors
    const getPublicInvestors = (userId) => new Promise((resolve, reject) => {
      userService.getPublicInvestors(userId)
        .then((response) => {
          response.json().then((investors) => {
            resolve(investors);
          });
        })
        .catch((error) => {
          error.json()
            .then((errorJson) => reject(errorJson.exceptionMessage))
            .catch(() => reject(error));
        });
    });

    return getPublicInfo.then((user) => {
      Promise.all([getPublicGoals(user.rid), getPublicInvestors(user.rid)])
        .then((responses) => {
          const data = {
            information: user,
            goals: responses[0],
            investors: responses[1],
          };

          // if the call has a goal name, get the goal from the public goals and get the supporters for it.
          if (goalName) {
            const selectedGoal = data.goals.find((x) => x.alias === goalName);

            if (!selectedGoal) {
              dispatch({ type: 'GET_USER_PUBLIC_FAIL', error: true });
              return;
            }

            goalService.getSupportersByGoalId(selectedGoal.rid)
              .then((response) => {
                response.json().then((supporters) => {
                  data.supporters = supporters;
                  data.goal = selectedGoal;

                  dispatch({ type: 'GET_USER_PUBLIC_FULLY_SUCCESS', data });
                });
              })
              .catch((error) => {
                dispatch({ type: 'GET_USER_PUBLIC_FAIL', error });
              });
          } else {
            dispatch({ type: 'GET_USER_PUBLIC_FULLY_SUCCESS', data });
          }
        })
        .catch((error) => {
          dispatch({ type: 'GET_USER_PUBLIC_FAIL', error });
        });
    })
      .catch((error) => {
        dispatch({ type: 'GET_USER_PUBLIC_FAIL', error });
        return Promise.reject();
      });
  },

};
